import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const FinalCTA = () => {
  const colors = {
    white: '#FFFFFF',
    primaryBg: '#1F305E',
    accent: '#2563EB',
    accentLight: '#DBEAFE',
    subText: '#4a5b6b',
  };

  return (
    <section
      className="py-32 relative overflow-hidden"
      style={{ backgroundColor: colors.white }}
    >
      <div className="max-w-4xl mx-auto px-6 relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4"
            style={{ color: colors.primaryBg }}
          >
            Building Success 
              Together
          </h2>

          <p
            className="text-base md:text-lg mb-8 max-w-3xl mx-auto text-center"
            style={{ color: colors.subText }}
          >
            At Kapil Tech, we connect organizations with the right talent to help them achieve growth.
          </p>

          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-semibold text-white transition-all"
            style={{ backgroundColor: colors.accent }}
          >
            Partner With Us
            <ArrowRight size={18} />
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;